<template>
  <div>
    <h1 class="has-text-weight-bold is-2 is-marginless title mb-24px">Style Guide</h1>

    <!-- Colors -->
    <div class="card">
      <ui-box>
        <div class="columns is-desktop" v-for="(colorsGroup, index) in colors" :key="`colors${index}`">
          <div class="column" v-for="color in colorsGroup" :key="color">
            <div :class="[`bgc__${color}`, 'py-32px', 'mb-8px']"></div>
            {{ color }}
          </div>
        </div>
      </ui-box>
    </div>
  </div>
</template>

<script>
import UiBox from '@/components/ui/box'

export default {
  components: { UiBox },
  data: () => ({
    // Colors
    colors: [
      // Black
      ['black', 'black-bis', 'black-ter'],
      // Grey
      ['grey-darker', 'grey-dark', 'grey', 'grey-light', 'grey-lighter', 'grey-lightest'],
      // White
      ['white-ter', 'white-bis', 'white'],
      // Named
      ['orange', 'yellow', 'green', 'turquoise', 'cyan', 'blue', 'blue-vibrant', 'purple', 'red']
    ]
  })
}
</script>

<style lang="scss" scoped>
.bgc {
  // Colors black
  &__black {
    background-color: $black;
  }
  &__black-bis {
    background-color: $black-bis;
  }
  &__black-ter {
    background-color: $black-ter;
  }

  // Colors grey
  &__grey-darker {
    background-color: $grey-darker;
  }
  &__grey-dark {
    background-color: $grey-dark;
  }
  &__grey {
    background-color: $grey;
  }
  &__grey-light {
    background-color: $grey-light;
  }
  &__grey-lighter {
    background-color: $grey-lighter;
  }
  &__grey-lightest {
    background-color: $grey-lightest;
  }

  // Colors white
  &__white-ter {
    background-color: $white-ter;
  }
  &__white-bis {
    background-color: $white-bis;
  }
  &__white {
    background-color: $white;
  }

  // Colors named
  &__orange {
    background-color: $orange;
  }
  &__yellow {
    background-color: $yellow;
  }
  &__green {
    background-color: $green;
  }
  &__turquoise {
    background-color: $turquoise;
  }
  &__cyan {
    background-color: $cyan;
  }
  &__blue {
    background-color: $blue;
  }
  &__blue-vibrant {
    background-color: $blue-vibrant;
  }
  &__purple {
    background-color: $purple;
  }
  &__red {
    background-color: $red;
  }
}
</style>